import { PropsWithChildren, createContext, useCallback, useRef, useState } from 'react'

import { ConfirmPopup, ConfirmPopupData, ConfirmPopupProps } from '@components/ConfirmPopup'

export const ConfirmPopupContext = createContext<(data: ConfirmPopupData) => Promise<boolean>>(async () => true)

export function ConfirmPopupProvider({ children }: PropsWithChildren) {
  const fn = useRef<Function>(() => {})

  const [isOpen, setIsOpen] = useState<boolean>(false)
  const [popupState, setPopupState] = useState<ConfirmPopupProps>({
    title: '',
    description: '',
    confirmBtnLabel: '',
    onClose: () => {},
    onConfirm: () => {},
  })

  const confirm = useCallback(
    (data: ConfirmPopupData): Promise<boolean> =>
      new Promise((resolve) => {
        fn.current = (choice: boolean) => {
          resolve(choice)
          setIsOpen(false)
        }

        setPopupState({ ...popupState, ...data })
        setIsOpen(true)
      }),
    [setIsOpen, setPopupState],
  )

  return (
    <ConfirmPopupContext.Provider value={confirm}>
      {children}

      {isOpen && (
        <ConfirmPopup
          {...popupState}
          onClose={() => fn.current(false)}
          onConfirm={() => fn.current(true)}
        />
      )}
    </ConfirmPopupContext.Provider>
  )
}
